import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'

interface Props {
  id?: number
  className?: string
}

const iconCache = new Map<number, string>()

const ItemIcon = ({ id, className }: Props) => {
  const [icon, setIcon] = useState<string | null>(
    id ? iconCache.get(id) ?? null : null,
  )

  useEffect(() => {
    if (!id) return
    if (iconCache.has(id)) {
      setIcon(iconCache.get(id) ?? null)
      return
    }
    fetch(`https://nether.wowhead.com/tooltip/item/${id}`).then(
      async (response) => {
        const json = await response.json()
        const resolved = json.icon?.replaceAll('-', '') || null
        if (resolved) iconCache.set(id, resolved)
        setIcon(resolved)
      },
    )
  }, [id])

  return (
    <figure className={cn('w-5 h-5', className)}>
      <img
        className={`w-full h-full duration-300 ${
          icon ? 'opacity-100' : 'opacity-0'
        } transition-opacity`}
        src={
          icon
            ? `https://render.worldofwarcraft.com/us/icons/36/${icon}.jpg`
            : undefined
        }
      />
    </figure>
  )
}

export default ItemIcon
